export const flatten = filter =>
{
    const filters = filter.filters;
    if (filters)
    {
        return filters.reduce((acc, curr) => acc.concat(curr.filters ? flatten(curr) : [curr]), []);
    }
    return [];
};
